import React, { useId } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

export function CategoryDeleteButton({ category, saving, onDelete }) {
    const reasonId = useId();
    const reason = category.assetCount > 0
        ? 'Cannot delete: assets are assigned to this category, including inactive assets.'
        : category.assetCount !== 0
          ? 'Category usage is unavailable. Refresh and try again.'
          : '';

    const button = (
        <Button
            size="sm"
            variant="outline-danger"
            disabled={saving || category.id === 'pending' || !!reason}
            aria-label={`Delete category ${category.description}`}
            aria-describedby={reason ? reasonId : undefined}
            onClick={() => onDelete(category)}
        >
            Delete
        </Button>
    );

    if (!reason) return button;

    return (
        <OverlayTrigger
            placement="top"
            trigger={['hover', 'focus']}
            overlay={<Tooltip id={reasonId}>{reason}</Tooltip>}
        >
            <span className="d-inline-block" tabIndex={0}>
                {button}
            </span>
        </OverlayTrigger>
    );
}
